<script setup>
import { useLayout } from '@/layout/composables/layout'

const { layoutConfig, onMenuToggle } = useLayout()

const outsideClickListener = ref(null)
const topbarMenuActive = ref(false)
const router = useRouter()
const visibleRight = ref(false)
const authStore = useAuthStore()
const appUserStore = useAppUserStore()

onMounted(() => {
  bindOutsideClickListener()
})

onBeforeUnmount(() => {
  unbindOutsideClickListener()
})

const firstUppercase = computed(() => {
  if (appUserStore.appUser.firstName.length === 0) {
    return '' // Return empty string for an empty input
  }

  const firstLetter =
    appUserStore.appUser.firstName.charAt(0).toUpperCase() +
    appUserStore.appUser.lastName.charAt(0).toUpperCase()
  return firstLetter
})

const logoUrl = computed(() => {
  return '/layout/images/staroil-logo.png'
})

const onTopBarMenuButton = () => {
  topbarMenuActive.value = !topbarMenuActive.value
}
const onSettingsClick = () => {
  topbarMenuActive.value = false
  router.push('/documentation')
}
const topbarMenuClasses = computed(() => {
  return {
    'layout-topbar-menu-mobile-active': topbarMenuActive.value,
  }
})

const bindOutsideClickListener = () => {
  if (!outsideClickListener.value) {
    outsideClickListener.value = event => {
      if (isOutsideClicked(event)) {
        topbarMenuActive.value = false
      }
    }
    document.addEventListener('click', outsideClickListener.value)
  }
}
const unbindOutsideClickListener = () => {
  if (outsideClickListener.value) {
    document.removeEventListener('click', outsideClickListener)
    outsideClickListener.value = null
  }
}
const isOutsideClicked = event => {
  if (!topbarMenuActive.value) return

  const sidebarEl = document.querySelector('.layout-topbar-menu')
  const topbarEl = document.querySelector('.layout-topbar-menu-button')

  return !(
    sidebarEl.isSameNode(event.target) ||
    sidebarEl.contains(event.target) ||
    topbarEl.isSameNode(event.target) ||
    topbarEl.contains(event.target)
  )
}
</script>

<template>
  <div class="layout-topbar">
    <router-link to="/" class="layout-topbar-logo">
      <img :src="logoUrl" alt="logo" />
      <span style="color: rgb(33, 120, 189)">Star</span>
      <span style="color: rgb(250, 203, 43)">Savers</span>
    </router-link>

    <button class="p-link layout-menu-button layout-topbar-button" @click="onMenuToggle()">
      <i class="pi pi-bars"></i>
    </button>

    <button
      class="p-link layout-topbar-menu-button layout-topbar-button"
      @click="onTopBarMenuButton()"
    >
      <i class="pi pi-ellipsis-v"></i>
    </button>

    <div class="layout-topbar-menu" :class="topbarMenuClasses">
      <button @click="visibleRight = true" class="p-link layout-topbar-button">
        <i class="pi pi-user"></i>
        <span>Profile</span>
      </button>
    </div>
    <Sidebar v-model:visible="visibleRight" header="Profile" position="right">
      <div class="p-fluid formgrid grid">
        <div class="field col-12 md:col-3">
          <div class="flex-auto">
            <Avatar
              :label="firstUppercase"
              class="mr-2"
              size="large"
              style="background-color: rgb(45, 187, 84); color: #ffffff"
            />
          </div>
        </div>
        <div class="field col-12 md:col-9">
          <div class="flex-auto">
            <h4>{{ appUserStore.appUser.firstName }} {{ appUserStore.appUser.lastName }}</h4>
            <h6>{{ appUserStore.appUser.emailAddress }}</h6>
          </div>
        </div>
        <div class="field col-12 md:col-6"></div>
        <div class="field col-12 md:col-6">
          <Button
            label="Logout"
            icon="pi pi-sign-out"
            severity="danger"
            outlined
            @click="authStore.logout(); router.push('/auth/login')"
          />
        </div>
      </div>
    </Sidebar>
  </div>
</template>

<style lang="scss" scoped></style>
